import { HttpClient } from "@/App/services/httpClient/HttpClient";
import type { HospitalStatus, HospitalStatuses, StatusPriority } from "@/App/types/twiageTypes";
import { StatusType } from "@/Pages/Statuses/StatusType";

type StatusPayload = {
  status: string;
  priority?: StatusPriority;
  type?: string;
  color?: string;
};

const hospitalsStatusesUrl = "/hospitalsStatuses";
const statusesQueryParams = { type: ["undefined", StatusType.ED, StatusType.IFT] };

export const StatusesService = {
  getHospitalsStatuses(): Promise<HospitalStatuses[]> {
    return HttpClient.get({
      path: hospitalsStatusesUrl,
      params: statusesQueryParams,
    });
  },

  getHospitalsAdministeredStatuses(): Promise<HospitalStatuses[]> {
    return HttpClient.get({
      path: hospitalsStatusesUrl,
      params: { canManageStatuses: true, ...statusesQueryParams },
    });
  },

  createHospitalStatus({
    hospitalId,
    payload,
  }: {
    hospitalId: string;
    payload: StatusPayload;
  }): Promise<HospitalStatus> {
    return HttpClient.post({ path: `${hospitalsStatusesUrl}/${hospitalId}`, body: payload });
  },

  editHospitalStatusById({
    hospitalId,
    statusId,
    payload,
  }: {
    hospitalId: string;
    statusId: string;
    payload: StatusPayload;
  }): Promise<HospitalStatus> {
    return HttpClient.patch({ path: `${hospitalsStatusesUrl}/${hospitalId}/${statusId}`, body: payload });
  },

  removeHospitalStatusById({
    hospitalId,
    statusId,
  }: {
    hospitalId: string;
    statusId: string;
  }): Promise<HospitalStatus> {
    return HttpClient.delete({ path: `${hospitalsStatusesUrl}/${hospitalId}/${statusId}` });
  },
};
